export class ModelingCategoryBffUrl {
  static index() {
    return `modeling/categories`;
  }
}
